<template>
    <div>
        <TermsOfServiceComponent />
    </div>
</template>

<script>
import TermsOfServiceComponent from '../components/TermsOfService-component.vue'
export default {
    name: 'TermsOfServicePage',
    components: {
        TermsOfServiceComponent
    }
}
</script>
<style scoped>

</style>